import { PermissionT } from "../types";

export const auroraSubmit = (permissions: PermissionT[]): boolean => {
  const p = permissions.find((permission) => permission.name === "aurora_submit");
  return !!p;
};

export default auroraSubmit;
